import { React, useEffect, useState } from "react";
import siteLogo from "../assets/images/site-logo.webp";
import { useNavigate, useLocation } from "react-router-dom";
import $ from "jquery";
import { toast } from "react-toastify";
import { useCity } from "../constants/CityProvider";

import ApiService from "../constants/ApiService";
import TranslateComponent from "../constants/TranslateComponent";

function Header({ siteData, isShowLoader }) {
  //it is used for navigation
  const { getList } = ApiService();

  const navigate = useNavigate();
  let location = useLocation();
  let [currentPathName, setcurrentPathName] = useState("/");
  const [width, setWidth] = useState(window.innerWidth);
  let [siteInfo, setSiteInfo] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const { setSelectedCity, selectedCity, setSelectedCityTagline, selectedCityTagline, cities, cityTaglines } = useCity();

  //change route function
  let changeRoute = (e, path) => {
    e.preventDefault();
    isShowLoader(true);
    if (path !== null && path !== "") {
      setcurrentPathName(path);
      navigate(path);
    }
    closeMenu();
  };

  // Close mobile nav drawer
  let closeMenu = () => {
    const nav = document.getElementById("otobix-nav");
    const overlay = document.getElementById("otobix-overlay");
    const hamburger = document.getElementById("otobix-hamburger");
    if (nav) nav.classList.remove("open");
    if (overlay) overlay.classList.remove("open");
    if (hamburger) hamburger.classList.remove("active");
  };


  //set window width
  let handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  let opencitymodal = (e) => {
    e.preventDefault();

    let $chooseCity = $("#choosecity");
    if ($chooseCity.is(":visible")) {
      $chooseCity.hide();
      $("body").removeClass("city-modal-active");
    } else {
      $chooseCity.show();
      $("body").addClass("city-modal-active");
    }
  };

  let closeModal = async () => {
    $("#choosecity").hide();
    $("body").removeClass("city-modal-active");
  };

  // Ensure modal cleanup on unmount
  useEffect(() => {
    return () => {
      $("body").removeClass("city-modal-active");
    };
  }, []);

  // Listen for Bootstrap modal hidden event to clean up body class
  useEffect(() => {
    const modal = document.getElementById("choosecity");
    if (modal) {
      $(modal).on("hidden.bs.modal", () => {
        $("body").removeClass("city-modal-active");
      });
    }
    return () => {
      if (modal) {
        $(modal).off("hidden.bs.modal");
      }
    };
  }, []);

  let handleCitySelect = (cityName, cityId) => {
    const currentCity = localStorage.getItem("city");

    if (currentCity === cityName) {
      setSelectedCity(cityName);
      $("#choosecity").hide();
      $("body").removeClass("city-modal-active");
      return; // Exit the function without navigating
    }

    setSelectedCity(cityName);
    setSelectedCityTagline(cityTaglines[cityName] || "");
    localStorage.setItem("cityId", cityId);
    localStorage.setItem("city", cityName);
    localStorage.setItem("cityTagline", cityTaglines[cityName] || "");
    $("body").removeClass("city-modal-active");

    // Check if the current path is "car-service-price"
    if (location.pathname === "/car-service-price") {
      toast.info("City changed. Redirecting to the previous page.");

      setTimeout(() => {
        navigate("/car-repair");
      }, 3000);
    }

    // Redirect if on buy or sell page
    const citySlug = cityName.toLowerCase().replace(/\s+/g, "-");
    if (location.pathname.includes("/buy-a-car")) {
      navigate(`/buy-a-car?city=${citySlug}`);
    } else if (location.pathname.includes("/sell-a-car")) {
      navigate(`/sell-a-car?city=${citySlug}`);
    }

    $("#choosecity").hide();
    $("body").removeClass("city-modal-active");
  };


  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    setSiteInfo(siteData);
  }, [siteData]);

  useEffect(() => {
    isShowLoader(true);

    window.scrollTo(0, 0);

    var elements = document.getElementsByClassName("slimmenu");
    if (elements && elements.length > 0 && width <= 768) {
      elements[0].style.display = "none";
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    setcurrentPathName(location.pathname);

    //scroll to top
    window.scrollTo(0, 0);

    $("body").prepend($('<div class="layoutovarlay"></div>'));
    $(".navigation").prepend(
      $('<div class="layoutovarlay2 menu-collapser"></div>')
    );
    $("body").removeClass("layout-expanded2");
  }, [location]);

  useEffect(() => {
    $("body").click();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const urlCity = urlParams.get("city");
    const storedCityId = localStorage.getItem("cityId");
    const storedTagline = localStorage.getItem("cityTagline");

    if (urlCity && cities && cities.length > 0) {
      const matchedCity = cities.find(c => 
        c.name.toLowerCase().replace(/\s+/g, '-') === urlCity.toLowerCase()
      );
      if (matchedCity) {
        setSelectedCity(matchedCity.name);
        const tagline = cityTaglines[matchedCity.name] || "";
        setSelectedCityTagline(tagline);
        localStorage.setItem("cityId", matchedCity.id);
        localStorage.setItem("city", matchedCity.name);
        localStorage.setItem("cityTagline", tagline);
        return; // City found in URL, skip show modal logic
      }
    }

    // Check if cityId is '1' and cityName is 'bangalore'
    if (storedCityId === "1") {
      // Remove both from local storage
      setSelectedCity("Cities");
      localStorage.removeItem("cityId");
      localStorage.removeItem("city");
    } else if (storedCityId) {
      const selectedCityData = cities.find(
        (city) => city.id.toString() === storedCityId
      );
      if (selectedCityData) {
        setSelectedCity(selectedCityData.name);
        setSelectedCityTagline(storedTagline || cityTaglines[selectedCityData.name] || "");
      }
    } else {
      setSelectedCity("Cities"); // default value
      setSelectedCityTagline("");
    }
  }, [cities, location.search]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const urlCity = urlParams.get("city");
    const storedCityId = localStorage.getItem("cityId");
    
    // If city is in URL, don't show the modal
    if (urlCity) return;

    // Check if cityId is '1' and cityName is 'bangalore'
    if (storedCityId === "1") {
      // Remove both from local storage
      setSelectedCity("Cities");
      localStorage.removeItem("cityId");
      localStorage.removeItem("city");
    }

    if (!storedCityId || storedCityId === "1") {
      let $chooseCity = $("#choosecity");
      $chooseCity.addClass("show");
      $chooseCity.show();
      $("body").addClass("city-modal-active");
    }
  }, []);

  return (
    <>
      <header className="otobix-header" id="otobix-header">
        <div className="otobix-header-inner container">

          {/* Logo */}
          <div className="otobix-logo">
            <a href="/" onClick={(e) => changeRoute(e, "/")}>
              <img src={siteLogo} alt="OtoBix" width={120} height={37} loading="lazy" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="otobix-nav" id="otobix-nav">
            <ul className="otobix-menu">
              <li className={currentPathName === "/" ? "active" : ""}>
                <a href="/" onClick={(e) => changeRoute(e, "/")}>Home</a>
              </li>
              <li className={currentPathName.includes("/sell-a-car") ? "active" : ""}>
                <a href="/sell-a-car" onClick={(e) => {
                  const slug = selectedCity !== "Cities" ? "?city=" + selectedCity.toLowerCase().replace(/\s+/g, "-") : "";
                  changeRoute(e, "/sell-a-car" + slug);
                }}>Sell A Car</a>
              </li>
              <li className={currentPathName.includes("/buy-a-car") ? "active" : ""}>
                <a href="/buy-a-car" onClick={(e) => {
                  const slug = selectedCity !== "Cities" ? "?city=" + selectedCity.toLowerCase().replace(/\s+/g, "-") : "";
                  changeRoute(e, "/buy-a-car" + slug);
                }}>Buy A Car</a>
              </li>

              {/* Finance Dropdown */}
              <li className="has-dropdown">
                <a href="#" onClick={(e) => e.preventDefault()}>
                  Finance <span className="nav-caret">›</span>
                </a>
                <ul className="otobix-dropdown">
                  <li className={currentPathName === "/new-car-finance" ? "active" : ""}>
                    <a href="/new-car-finance" onClick={(e) => changeRoute(e, "/new-car-finance")}>New Car Finance</a>
                  </li>
                  <li className={currentPathName === "/pre-owned-car-finance" ? "active" : ""}>
                    <a href="/pre-owned-car-finance" onClick={(e) => changeRoute(e, "/pre-owned-car-finance")}>Pre-Owned Car Finance</a>
                  </li>
                  <li className={currentPathName === "/loan-against-car" ? "active" : ""}>
                    <a href="/loan-against-car" onClick={(e) => changeRoute(e, "/loan-against-car")}>Loan Against Car</a>
                  </li>
                </ul>
              </li>

              <li className={currentPathName === "/insurance" ? "active" : ""}>
                <a href="/insurance" onClick={(e) => changeRoute(e, "/insurance")}>Insurance</a>
              </li>

              {/* Car Services Dropdown */}
              <li className="has-dropdown">
                <a href="#" onClick={(e) => e.preventDefault()}>
                  Car Services <span className="nav-caret">›</span>
                </a>
                <ul className="otobix-dropdown">
                  <li className={currentPathName === "/road-side-assistance" ? "active" : ""}>
                    <a href="/road-side-assistance" onClick={(e) => changeRoute(e, "/road-side-assistance")}>Road Side Assistance</a>
                  </li>
                  <li className={currentPathName === "/warranty" ? "active" : ""}>
                    <a href="/warranty" onClick={(e) => changeRoute(e, "/warranty")}>Warranty</a>
                  </li>
                  <li className={currentPathName === "/car-service-booking-status" ? "active" : ""}>
                    <a href="/car-service-booking-status" onClick={(e) => changeRoute(e, "/car-service-booking-status")}>Track Request</a>
                  </li>
                  <li className={currentPathName === "/car-inspection" ? "active" : ""}>
                    <a href="/car-inspection" onClick={(e) => changeRoute(e, "/car-inspection")}>Car Inspection</a>
                  </li>
                </ul>
              </li>

              {/* About Dropdown */}
              <li className="has-dropdown">
                <a href="#" onClick={(e) => e.preventDefault()}>
                  About <span className="nav-caret">›</span>
                </a>
                <ul className="otobix-dropdown">
                  <li className={currentPathName === "/about-us" ? "active" : ""}>
                    <a href="/about-us" onClick={(e) => changeRoute(e, "/about-us")}>About Us</a>
                  </li>
                  <li className={currentPathName === "/contact-us" ? "active" : ""}>
                    <a href="/contact-us" onClick={(e) => changeRoute(e, "/contact-us")}>Contact Us</a>
                  </li>
                </ul>
              </li>
            </ul>

            {/* Mobile-only contact buttons at bottom of drawer */}
            <div className="otobix-mobile-contact">
              <a href={"tel:" + (siteInfo?.site_phone_number || "+919088822999")} className="otobix-mobile-call">
                📞 {siteInfo?.site_phone_number || "+91 90888 22999"}
              </a>
              <a href={"mailto:" + (siteInfo?.site_email || "info@otobix.in")} className="otobix-mobile-email">
                ✉️ {siteInfo?.site_email || "info@otobix.in"}
              </a>
            </div>
          </nav>


          {/* Right side: City + CTA */}
          <div className="otobix-header-right">
            {/* City Selector */}
            <button className="otobix-city-btn" onClick={(e) => opencitymodal(e)}>
              <span className="city-icon">📍</span>
              <span className="city-label">{selectedCity === "Cities" ? "Select City" : selectedCity}</span>
              <span className="city-arrow">▾</span>
            </button>

            {/* Call CTA */}
            <a href={"tel:" + (siteInfo?.site_phone_number || "+919088822999")} className="otobix-call-btn" aria-label="Call us">
              <span className="call-icon">📞</span>
              <span className="call-text">{siteInfo?.site_phone_number || "+91 90888 22999"}</span>
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button className="otobix-hamburger" id="otobix-hamburger" aria-label="Menu" onClick={() => {
            document.getElementById("otobix-nav").classList.toggle("open");
            document.getElementById("otobix-overlay").classList.toggle("open");
            document.getElementById("otobix-hamburger").classList.toggle("active");
          }}>
            <span></span><span></span><span></span>
          </button>
        </div>

        {/* Mobile overlay */}
        <div className="otobix-overlay" id="otobix-overlay" onClick={() => {
          document.getElementById("otobix-nav").classList.remove("open");
          document.getElementById("otobix-overlay").classList.remove("open");
          document.getElementById("otobix-hamburger").classList.remove("active");
        }}></div>
      </header>

      {/* choose your city modal*/}



      <div
        class="modal choosecity commonModal"
        id="choosecity"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
          <div class="modal-contents">
            <div class="modal-header">
              <h5
                class="modal-title"
                id="exampleModalLabel"
                style={{ color: "black" }}
              >
                Choose Your City
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModal()}
              ></button>
            </div>
            <div class="modal-body">
              <div className="city-search-container mb-4">
                <div className="input-group">
                  <span className="input-group-text bg-white border-end-0">
                    <i className="icon-search text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0 shadow-none"
                    placeholder="Search your city..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ borderRadius: "0 8px 8px 0" }}
                  />
                </div>
              </div>
              <div class="city-container">
                {cities
                  .filter((city) =>
                    city.name.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((city) => {
                  const cityImageMap = {
                    "kolkata": "/cities/kolkata.png",
                    "howrah": "/cities/Howrah.png",
                    "hooghly": "/cities/hooghly.png",
                    "malda": "/cities/Malda.png",
                    "english bazar": "/cities/Malda.png",
                    "english bazar/malda": "/cities/Malda.png",
                    "murshidabad": "/cities/Murshidabad.jpg",
                    "nadia": "/cities/mayapur.png",
                    "baharampur": "/cities/bahrampur.jpg",
                    "bahrampur": "/cities/bahrampur.jpg",
                    "bardhaman": "/cities/Bardhaman.png",
                    "habra": "/cities/Habra.webp",
                    "kharagpur": "/cities/Kharagpur IIT.jpg",
                    "durgapur": "/cities/Durgapur.png",
                    "asansol": "/cities/Asansol.png",
                    "siliguri": "/cities/Salugara Monastery Siliguri.jpg",
                    "bhubaneswar": "/cities/bhubaneswar.webp",
                    "cuttack": "/cities/Cuttack.png",
                    "gaya": "/cities/Gaya.png",
                    "maheshtala": "/cities/Maheshtala.png",
                    "rajpur sonarpur": "/cities/Rajpur Sonarpur.png",
                    "chandannagar": "/cities/Chandannagar.png",
                    "santipur": "/cities/Shantipur.png",
                    "bally": "/cities/Bally.png",
                    "patna": "https://s3.ap-south-1.amazonaws.com/prodimages.automovill.com/icon/patna.webp",
                    "ranchi": "https://s3.ap-south-1.amazonaws.com/prodimages.automovill.com/icon/ranchi.webp"
                  };

                  const imageUrl = cityImageMap[city.name.toLowerCase()] || `https://s3.ap-south-1.amazonaws.com/prodimages.automovill.com/icon/${city.name.toLowerCase()}.webp`;

                  return (
                    <div
                      className="text-center img-hover-zoom--colorize"
                      key={city.id}
                    >
                      <a
                        key={city.id}
                        className="city-pointer"
                        onClick={() => handleCitySelect(city.name, city.id)}
                      >
                        <img
                          src={imageUrl}
                          alt={city.name}
                          className="rounded-circle border border-light m-2"
                          loading="lazy"
                          fetchpriority="low"
                          onError={(e) => {
                            e.target.onerror = null; // Prevents looping
                            e.target.src =
                              "https://placehold.co/100x100?text=No+Image";
                          }}
                          style={
                            city.name.toLowerCase() === "bhubaneswar" ||
                              city.name.toLowerCase() === "siliguri"
                              ? { width: "100px", height: "100px" } // Set your desired dimensions
                              : {}
                          }
                        />
                        <h5 className="city-name" style={{ marginBottom: "2px" }}>{city.name}</h5>
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <a href="https://wa.me/919088822999" class="float" target="_blank">
        <i class="icon-whatsapp my-float"></i>
      </a>
    </>
  );
}

export default Header;
